<div nz-flex [nzVertical]="true" [nzJustify]="'center'" [nzAlign]="'center'" [nzGap]="'middle'">
  <div>
    @if (newPassword) {
      <div
        class="new-password"
        nz-flex
        [nzVertical]="true"
        [nzJustify]="'center'"
        [nzAlign]="'center'"
      >
        <div>Nowe hasło:</div>
        <div>
          <span class="password-value" nz-typography nzCopyable
            ><strong>{{ newPassword }}</strong></span
          >
        </div>
      </div>
    } @else {
      <div class="new-password">
        <span>Kliknij by wygenerować nowe hasło</span>
      </div>
    }
  </div>
  <button
    nz-button
    nzType="primary"
    (click)="onChangePassword()"
    [nzLoading]="isLoading()"
    [disabled]="isLoading()"
  >
    <span nz-icon nzType="reload"></span>
    Zmień hasło
  </button>
</div>
